<template>
  <div id="medium">
    <div class="nft-logo"><img :src="nftInfo.picture" alt="" /></div>
    <div class="nftInfo">
      <div>
        <el-popover
          placement="top"
          :trigger="triggerType"
          :offset="-18"
          :content="nftInfo.name"
        >
          <div slot="reference" class="name">{{ nftInfo.name }}</div>
        </el-popover>
      </div>
      <p class="num" v-if="nftInfo.type === 'MINT'">x{{ nftInfo.quantity }}</p>
      <p class="num" v-else>{{ nftInfo.uniqueId }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import common from "@/utils/common";

export default {
  name: "medium",
  data() {
    return {
      triggerType: "hover",
    };
  },
  mounted() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
  },
  activated() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
  },
  computed: {
    ...mapState("buyNftHome", {
      nftInfo: (state) => state.nftInfo,
    }),
  },
};
</script>

<style lang="scss" scoped>
#medium {
  width: 2.2rem;
  margin: 0 auto;
}
.nft-logo {
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 0.06rem;
  img {
    height: 2.2rem;
    border-radius: 0.06rem;
  }
}
.nftInfo {
  width: 2.2rem;
  //height: 0.36rem;
  //background: rgba(83, 0, 218, 0.05);
  //border: 1px solid #5300DA;
  //border-radius: 0.18rem;
  margin-top: 0.08rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .name {
    max-width: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Medium;
    font-weight: 500;
    font-size: 0.16rem;
    line-height: 0.2rem;
    color: #031633;
    cursor: pointer;
  }
  .num {
    font-family: Regular;
    font-weight: 400;
    font-size: 0.14rem;
    line-height: 0.18rem;
    color: #6e7687;
    margin-left: 0.12rem;
  }
}
</style>
